import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

const HEADER_OFFSET = 96;

const useHashScroll = () => {
  const location = useLocation();
  useEffect(() => {
    if (!location.hash) {
      window.scrollTo({ top: 0, behavior: "auto" });
      return;
    }
    const id = location.hash.replace("#", "");
    const scrollToTarget = () => {
      const el = document.getElementById(id);
      if (!el) return false;
      const y =
        el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
      window.scrollTo({ top: y, behavior: "smooth" });
      return true;
    };
    // Retry a couple of times to allow images / lazy content to render.
    if (!scrollToTarget()) {
      const timeouts = [50, 200, 500, 900].map((ms) =>
        setTimeout(scrollToTarget, ms),
      );
      return () => timeouts.forEach(clearTimeout);
    }
  }, [location.pathname, location.hash]);
};

const useFadeInOnScroll = () => {
  useEffect(() => {
    const els = document.querySelectorAll(".fade-in");
    if (!("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("is-visible"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" },
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
};

export const Layout = ({ children }) => {
  useHashScroll();
  useFadeInOnScroll();
  return (
    <div className="App min-h-screen flex flex-col">
      <Header />
      <main className="flex-1" data-testid="main-content">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
